// extracted by mini-css-extract-plugin
module.exports = {"selector":"select_selector__3-yQr"};